import Client from './client';

export default class ClassificationProductSummaryPages extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getOrganizations(options = {}) {
    return this.makeRequest(`${this.host}/classification/organizations`, options);
  }

  getProducts(options = {}) {
    return this.makeRequest(`${this.host}/classification/products`, options);
  }

}
